// extracted by css-extract-rspack-plugin
export default {"counter":"_812c5ec2"};